import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ModernLoginScreen } from './ModernLoginScreen';
import { useAuth } from '../contexts/AuthContext';

export function LoginDemo() {
  const navigate = useNavigate();
  const { user, isAuthenticated, logout } = useAuth();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  // If user is authenticated, redirect to dashboard
  if (isAuthenticated && user) {
    navigate('/dashboard');
    return null;
  }

  return <ModernLoginScreen />;
}
